import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';
import { ButtonStyleTypes, ButtonSizes } from '../../../atoms/buttons/enums.js';
import { renderInteractiveElement } from '../../../atoms/generic-elements/interactive-element/index.js';
import { handleQuestionnareReset } from '../utils/index.js';

/* eslint-disable no-useless-concat */
const primaryButtonClass = 'primary-button';
const renderOptionalListItem = (ctx) => ctx.selectedOptions[4] && ctx.selectedOptions[4].optionName.length
    ? x `<li><span>${ctx.dataCopy.resultsPage.answersList[4].staticText}</span> <span style="color:#aa0061">${ctx.selectedOptions[4].optionName}</span></li>`
    : null;
const renderListItems = (ctx, maxlength) => {
    var _a;
    const arr = [];
    for (let i = 0; i <= maxlength; i += 1) {
        const currentOption = (_a = ctx.dataCopy.resultsPage.answersList[i].options) === null || _a === void 0 ? void 0 : _a.find((o) => o.optionName === ctx.selectedOptions[i].optionName);
        arr.push(x `<li><span>${o(ctx.dataCopy.resultsPage.answersList[i].staticText)}</span> <span style="color:#aa0061">${o(currentOption === null || currentOption === void 0 ? void 0 : currentOption.highlightedText)}</span></li>`);
    }
    return arr;
};
const renderRecommendations = (ctx) => {
    var _a, _b;
    const primaryCta = ctx.dataCopy.resultsPage.recommendations.startOverBtn &&
        x `<generic-button styleType="dark" type="primary-button" @click="${() => handleQuestionnareReset(ctx)}">${renderInteractiveElement({
            mainClass: primaryButtonClass,
            isAnchor: false,
            text: ctx.dataCopy.resultsPage.recommendations.startOverBtn.text,
            style: ButtonStyleTypes.DARK,
            size: ButtonSizes.REGULAR,
            mobileInverted: false,
            mobileWhite: false,
            disabled: false,
            rtl: false,
        })}</generic-button>`;
    const secondaryCta = ctx.dataCopy.resultsPage.recommendations.contactBtn &&
        x `<generic-button slot="secondary-cta" styleType="outlined-dark" text="primary-button">${renderInteractiveElement({
            mainClass: primaryButtonClass,
            isAnchor: true,
            text: ctx.dataCopy.resultsPage.recommendations.contactBtn.text,
            href: ctx.dataCopy.resultsPage.recommendations.contactBtn.href,
            style: ButtonStyleTypes.OUTLINED_DARK,
            size: ButtonSizes.REGULAR,
            mobileInverted: false,
            mobileWhite: false,
            disabled: false,
            rtl: false,
        })}</generic-button>`;
    return x `<div class="ps-results-recommendations"><div class="ps-results-recommendations__image"><img loading="lazy" src="${(_a = ctx.recommendationImageUrl) !== null && _a !== void 0 ? _a : ''}" alt="${(_b = ctx.recommendationImageAltText) !== null && _b !== void 0 ? _b : 'Recommended products'}"></div><div class="ps-results-recommendations__content-wrapper"><div class="ps-results-recommendations__content"><p class="ps-results-recommendations__headline">${ctx.dataCopy.resultsPage.recommendations.headline}</p><p class="ps-results-recommendations__paragraph">${ctx.returnString(ctx.dataCopy.resultsPage.recommendations.listHeader)}</p><ul class="ps-results-recommendations__list">${renderListItems(ctx, ctx.steps.length - 1)} ${renderOptionalListItem(ctx)}</ul><p class="ps-results-recommendations__paragraph">${ctx.dataCopy.resultsPage.recommendations.listFooter}</p><div class="ps-results-recommendations__cta">${l(primaryCta)} ${l(secondaryCta)}</div></div></div></div>`;
};
// eslint-disable-next-line consistent-return
const renderProductCards = (ctx) => {
    var _a, _b, _c, _d, _e, _f;
    if (ctx.apiResponseData) {
        const arr = [];
        for (let i = 0; i < ctx.apiResponseData.products.length; i += 1) {
            arr.push(x `<div slot="slide-container" class="swiper-slide"><content-card cardType="product" responsive clickable url="${(_a = ctx.apiResponseData) === null || _a === void 0 ? void 0 : _a.products[i].url}" ctaText="${(_b = ctx.apiResponseData) === null || _b === void 0 ? void 0 : _b.products[i].linkText}"><img slot="image" src="${(_c = ctx.apiResponseData) === null || _c === void 0 ? void 0 : _c.products[i].image}" alt="${(_d = ctx.apiResponseData) === null || _d === void 0 ? void 0 : _d.products[i].title} poster"><p slot="heading">${o((_e = ctx.apiResponseData) === null || _e === void 0 ? void 0 : _e.products[i].title)}</p><p slot="body-text">${o((_f = ctx.apiResponseData) === null || _f === void 0 ? void 0 : _f.products[i].description)}</p></content-card></div>`);
        }
        return arr;
    }
};
const renderRequestSampleButton = (ctx) => x `<generic-button type="primary-button" styleType="${ButtonStyleTypes.DARK}" slot="cta" popupId="${ctx.dataCopy.resultsPage.productSearch.popupId}">${renderInteractiveElement({
    mainClass: primaryButtonClass,
    isAnchor: false,
    text: ctx.dataCopy.resultsPage.productSearch.ctaText,
    style: ButtonStyleTypes.DARK,
    size: ButtonSizes.REGULAR,
    mobileInverted: false,
    mobileWhite: false,
    disabled: false,
    rtl: false,
})}</generic-button>`;
const renderResultsPage = (ctx) => x `<div class="ps-results"><div class="ps-results__products"><product-preview dir="${ctx.rtl ? 'rtl' : 'ltr'}" ?rtl="${ctx.rtl}" nextText="Next" previousText="Previous"><p slot="headline">${o(ctx.dataCopy.resultsPage.productSearch.headline)}</p>${renderRequestSampleButton(ctx)} ${renderProductCards(ctx)}</product-preview><div class="ps-results__request-sample-btn-mobile">${renderRequestSampleButton(ctx)}</div></div>${renderRecommendations(ctx)}<div class="ps-results__other-products"><slot name="other-products"></slot></div></div>`;

export { renderProductCards, renderRecommendations, renderResultsPage };
